import { z } from 'zod';

// ---------------------------------------------------------------------------
// SiteContext — resolved site configuration, returned by GET /v1/sites/resolve
// Fields match the `sites` table row in db-types.ts (snake_case per wire).
// ---------------------------------------------------------------------------

export const SiteContextSchema = z.object({
  site_code: z.string(),
  host: z.string(),
  default_lang: z.string(),
  supported_langs: z.array(z.string()),
  default_currency: z.string(),
  country_code: z.string(),
});
export type SiteContext = z.infer<typeof SiteContextSchema>;

// ---------------------------------------------------------------------------
// ResolveSite — request / response shapes for GET /v1/sites/resolve?host=
// ---------------------------------------------------------------------------

export const ResolveSiteRequestSchema = z.object({
  host: z.string().min(1),
});
export type ResolveSiteRequest = z.infer<typeof ResolveSiteRequestSchema>;

// Response is the SiteContext itself
export const ResolveSiteResponseSchema = SiteContextSchema;
export type ResolveSiteResponse = SiteContext;
